export default {"src":"/_next/static/media/plus.8fc9da10.svg","height":16,"width":16};